import React, { useState, useRef, useEffect } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import BackArrows from "../../Form/BackArrow/BackArrows";
import { useLocation, useNavigate } from "react-router-dom";
import { getIcons } from "../../Constant/Constant";
import ConfirmationModal from "../../shareableContainer/ConfirmationModal";
import teamService from "../../Services/TeamService";
import CPManageService from "../../Services/CPManageService";
import { showErrorToast, showSuccessToast } from "../../Constant/Notification";
import { ToastContainer } from "react-toastify";

const AssignTeamMemberPage = () => {
  const icons = getIcons();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const location = useLocation();
  const selectedLeads = location.state?.selectedLeads || []; 
  const userObj = JSON.parse(localStorage.getItem("userData") || "{}");
  const userRole = userObj?.user?.role || "Admin";

  console.log("Selected Leads:", selectedLeads);


  

  const [teams, setTeams] = useState([]);
  const [searchMember, setSearchMember] = useState("");
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [visible, setVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredTeams, setFilteredTeams] = useState([]);
  const [filteredMembers , setFilteredMembers] = useState([]);

  

  useEffect(() => {
    const getTeamList = async () => {
      try {
        const response = await teamService.getTeamName();
        setTeams(response?.data?.teams || []);
        setFilteredTeams(response?.data?.teams || []);
      } catch (error) {
        console.error(error);
      }
    };
    getTeamList();
  }, []);

 // console.log("Team filteredTeams ", filteredTeams );

  useEffect(() => {
    const filtered = teams.filter((team) =>
      team.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredTeams(filtered);
  }, [searchQuery]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleBack = () => {
    navigate(-1);
  };

  const handleMemberSelect = (memberId) => {
    console.log("memberSelect", memberId )
    setSelectedMembers([memberId]);
  };


  const handleAssign = async () => {
    if (selectedMembers.length > 0) {
      setShowConfirmation(true);
    }
  };

  const handleSelectTeam = async (team) => {
    setSelectedTeam(team);
    try{
      const response = await  teamService.getTeamData(team?.teamId)
      setFilteredMembers(response.data);
    }catch(err){
      console.error("Error getting team data")
    }
    
    setVisible(false);
  };

  const handleConfirmAction = async () => {
    console.log(
      `Assigned ${selectedMembers.length} members from ${selectedTeam?.name}`
    );
  
    if (selectedMembers.length === 0) {
      showErrorToast("Please select at least one member to assign.");
      return;
    }
  
    setShowConfirmation(false);
  
    try {
      const body = {
        leadIds: selectedLeads || [], 
        assignedToUserId: selectedMembers[0], 
        assignedTeamId: selectedTeam?.teamId || null,
      };
  
      const response = await CPManageService.CPAssignMultipleLeads(body);
      console.log("Response:", response);
      if(response.data){
        showSuccessToast(response.data)
        setTimeout(()=>{
          const path = userRole === "Admin" ? "/admin" : "/cmo";
          navigate(`${path}/cp-management`)
        },2000)
      }
    } catch (error) {
      showErrorToast(error?.message || "An error occurred while assigning leads.");
      console.error("API Error:", error);
    }
  };
  
  const handleCancelConfirmation = () => {
    setShowConfirmation(false);
  };
  

const filteredMember = filteredMembers
  ? [
      ...(filteredMembers.BOD || []),
      ...(filteredMembers.members || []),
      ...(filteredMembers.MD ? [filteredMembers.MD] : []),
    ].filter((member) =>
      member?.name?.toLowerCase().includes(searchMember.toLowerCase())
    )
  : [];


  console.log(" searching" ,filteredMembers )



  return (
    <div className="bg-appGrayBackground pb-16">
       <AdminAppBar />
      <ToastContainer/>
      <div className="mt-20 pt-8 px-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-6">
            <BackArrows onClick={handleBack} />
            <h1 className="text-[32px] font-semibold">
              Assign to Team Members
            </h1>
          </div>
        </div>

        <div className="flex items-center justify-between gap-8 mt-[50px]">
          <div className="flex items-center justify-start gap-8">
            <div className="border-2 w-52 text-center bg-white text-[20px] font-semibold px-4 py-3 rounded-2xl">
              Total Count: {selectedLeads?.length}
            </div>
          </div>

          <button
            onClick={handleAssign}
            className={`border-2 ${
              selectedMembers.length === 0
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-customGreen cursor-pointer hover:bg-green-600"
            } text-white w-40 text-[20px] font-semibold px-4 py-3 rounded-2xl transition-colors`}
            disabled={selectedMembers.length === 0}
          >
            Assign
          </button>
        </div>

        <div className="mt-[50px]">
          <div className="bg-white p-5 rounded-xl border-2 flex flex-col">
            <div className="relative">
              <div
                className="bg-gray-100 rounded-md px-4 py-3 w-full md:w-96 flex justify-between items-center cursor-pointer"
                onClick={() => setVisible(!visible)}
              >
                <span className="text-gray-700">
                  {selectedTeam ? selectedTeam.name : "Select a Team"}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-gray-500"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>

              {visible && (
                <div
                  ref={dropdownRef}
                  className="absolute max-h-48 overflow-y-auto mt-2 w-full md:w-96 bg-white border-2 z-10 divide-y divide-gray-200 rounded-lg shadow"
                >
                  <div className="w-full px-3 py-3 top-0 bg-white">
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder="Search Team"
                      className="w-full px-4 py-2 rounded-md text-sm border border-gray-300"
                    />
                  </div>

                  <ul className="py-2 text-sm text-gray-700">
                    {filteredTeams.map((team, index) => (
                      <li key={index}>
                        <div
                          onClick={() => handleSelectTeam(team)}
                          className="block font-primaryFont cursor-pointer px-4 py-2 hover:bg-gray-100"
                        >
                          {team.name}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            {selectedTeam ? (
              <div className="bg-white border-2 mt-6 rounded-xl p-8">
                <div className="mb-6">
                  <div className="flex flex-col gap-2">
                    <div>Members</div>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-gray-400"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                          />
                        </svg>
                      </div>
                      <input
                        type="text"
                        className="border-2 pl-10 px-3 py-2 w-full md:w-80 rounded-xl"
                        placeholder="Search Member"
                        value={searchMember}
                        onChange={(e) => setSearchMember(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="border border-gray-200 rounded-xl p-4">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {filteredMember.map((member, index) => {
                      const memberId = index + 1;
                      const isSelected = selectedMembers.includes(member?.id);

                      return (
                        <div
                          key={index}
                          className="flex items-center space-x-4 p-3 bg-gray-100 rounded-md cursor-pointer"
                          onClick={() => handleMemberSelect(member?.id)}
                        >
                          <button
                            className={`w-6 h-6 rounded-full border flex items-center justify-center ${
                              isSelected
                                ? "bg-green-500 border-green-500"
                                : "border-gray-400"
                            }`}
                          >
                            {isSelected && (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4 text-white"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            )}
                          </button>
                          <span className="text-gray-700">{member?.name}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            ) : (
              <div className="bg-white  items-center flex justify-center border-2 mt-6 rounded-xl p-8">
                <img src={icons?.notFoundImage} />
              </div>
            )}
          </div>
        </div>
      </div>

      <ConfirmationModal
        showModal={showConfirmation}
        icon={icons?.confirmationWarning}
        title="Are You Sure?"
        message={`Are you sure you want to assign ${selectedMembers.length} members?`}
        onConfirm={handleConfirmAction}
        onCancel={handleCancelConfirmation}
      />
    </div>
  );
};

export default AssignTeamMemberPage;
